/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_Twitterdescription1Inputs */

const ja_company_meta_twitterdescription1 = /** @type {(inputs: Company_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2016年に東京で設立された「株式会社プレイブレーン（PLAYBRAIN）」は、日本・アジア市場に特化したゲームマーケティング・eスポーツ制作会社です。ゲーム業界、eスポーツ、デジタルマーケティングにおける豊富な経験を活かし、ゲームパブリッシャー、デベロッパー、ブランド企業の国内外における成長を支援しています。日本・アジア市場だけでなく、欧米市場へ向けたマーケティングやコミュニケーションもサポートしています。`)
};

const en_company_meta_twitterdescription1 = /** @type {(inputs: Company_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founded in Tokyo in 2016, PLAYBRAIN is a game marketing agency specializing in Japan and Asia. With over a decade of experience in gaming, esports, and digital marketing, we help publishers, developers, and brands connect with players through creative campaigns, live events, and innovative digital experiences.`)
};

/**
* | output |
* | --- |
* | "Founded in Tokyo in 2016, PLAYBRAIN is a game marketing agency specializing in Japan and Asia. With over a decade of experience in gaming, esports, and digit..." |
*
* @param {Company_Meta_Twitterdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_meta_twitterdescription1 = /** @type {((inputs?: Company_Meta_Twitterdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_Twitterdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_twitterdescription1(inputs)
	return en_company_meta_twitterdescription1(inputs)
});
export { company_meta_twitterdescription1 as "company_meta_twitterDescription" }